"use client";

import { c as _c } from "react/compiler-runtime";
import { Container } from "@/components/container";
import { Scrollspy } from "@/components/reui/scrollspy";
import { cn } from "@/lib/utils";
import { useEffect, useRef, useState } from "react";
type CourseNavigationProps = {
  data: {
    courseNavigation: {
      id: string;
      title: string;
    }[];
  };
};
const CourseNavigation = t0 => {
  const $ = _c(15);
  const {
    data
  } = t0;
  const [activeId, setActiveId] = useState("");
  const [offset, setOffset] = useState(85);
  const targetRef = useRef(null);
  const listRef = useRef(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      targetRef.current = document;
      const updateOffset = () => {
        const isBannerVisible = document.documentElement.getAttribute("data-offer-banner") === "visible";
        setOffset(isBannerVisible ? 120 : 85);
      };
      updateOffset();
      const observer = new MutationObserver(() => {
        updateOffset();
      });
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ["data-offer-banner"]
      });
      return () => observer.disconnect();
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[2] !== activeId) {
    t3 = () => {
      if (!activeId || !listRef.current) {
        return;
      }
      const activeEl = listRef.current.querySelector(`[data-scrollspy-anchor="${activeId}"]`);
      if (activeEl) {
        activeEl.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center"
        });
      }
    };
    t4 = [activeId];
    $[2] = activeId;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== activeId || $[6] !== data.courseNavigation) {
    let t6;
    if ($[8] !== activeId) {
      t6 = section => {
        const isActive = activeId === section.id;
        return <li key={section.id} className="relative shrink-0 py-3"><button data-scrollspy-anchor={section.id} className={cn("focus-visible:ring-primary relative block cursor-pointer rounded-md text-sm font-medium transition-all duration-300 select-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden", isActive ? "text-primary font-semibold" : "text-muted-foreground hover:text-foreground")}>{section.title}</button><div className={cn("bg-primary shadow-primary/30 absolute right-1 bottom-0 left-1 h-0.75 origin-center rounded-t-full shadow-sm transition-all duration-300 ease-out", isActive ? "opacity-100" : "opacity-0")} /></li>;
      };
      $[8] = activeId;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    t5 = data.courseNavigation.map(t6);
    $[5] = activeId;
    $[6] = data.courseNavigation;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <div className="relative flex items-center justify-between"><ul ref={listRef} className="no-scrollbar flex w-full scrollbar-none items-center gap-6 overflow-x-auto scroll-smooth px-2 py-1 [-ms-overflow-style:none] sm:justify-center sm:gap-8 md:gap-10 [&::-webkit-scrollbar]:hidden">{t5}</ul></div>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== offset || $[13] !== t6) {
    t7 = <section data-course-nav={true} className="bg-background/85 sticky inset-x-0 top-16 z-20 shadow-lg backdrop-blur-lg transition-all duration-300"><Container><Scrollspy targetRef={targetRef} onUpdate={setActiveId} offset={offset} history={false}>{t6}</Scrollspy></Container></section>;
    $[12] = offset;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
export default CourseNavigation;